import type { RemoveRouteFromPlanArgs } from "./types";
import type { PlanV3 } from "./types";

export const removeRouteFromPlan = ({
  plan,
  groupLabel,
  routeId,
}: RemoveRouteFromPlanArgs): PlanV3 => {
  const routeGroups = plan.routeGroups.map((group) => {
    if (group.label !== groupLabel) return group;

    const filteredRoutes = group.routes.filter(
      (route) => route.id !== routeId,
    );
    const updatedMeters = filteredRoutes.reduce(
      (sum, route) => sum + (Number(route.meters) || 0),
      0,
    );

    return {
      ...group,
      routes: filteredRoutes,
      meters: updatedMeters,
    };
  });

  const nonEmptyRouteGroups = routeGroups.filter(
    (group) => group.routes.length > 0,
  );

  return {
    ...plan,
    routeGroups: nonEmptyRouteGroups,
  };
};
